import React, { useCallback, useEffect, useState } from 'react'
import { Grid, Typography, Divider, Card, CardContent, CircularProgress, CardHeader, Avatar, Menu, MenuItem } from '@material-ui/core'
import { CardExameSolicitado } from 'components/Cards/CardExameSolicitado' // eslint-disable-line
import moment from 'moment'
import FolderIcon from '@material-ui/icons/Folder'
import localization from 'moment/locale/pt-br'
import { setIdSolicitacaoExame } from 'actions'
import { useSolicitacaoExameService } from 'hooks/useSolicitacaoExameService'
import { useDispatch } from 'react-redux'
import useRouter from 'utils/useRouter'
import PersonIcon from '@material-ui/icons/Person'
import BusinessIcon from '@material-ui/icons/Business'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import DescriptionIcon from '@material-ui/icons/Description'
import GavelIcon from '@material-ui/icons/Gavel'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import Tooltip from '@material-ui/core/Tooltip'
import { ObjetoAvatar } from 'components' // 🛡️ Integrado na malha global!

import useStyles from './styles'

export const CardSolicitacaoExame = (props) => {
  const { idSolicitacaoExame, omitirExamesSolicitados, solicitacao } = props
  const solicitacaoExameService = useSolicitacaoExameService()
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const dispatch = useDispatch()
  const router = useRouter()
  const [solicitacaoExame, setSolicitacaoExame] = useState(solicitacao || null)
  const [examesSolicitados, setExamesSolicitados] = useState(solicitacao?.exSols || null)
  const [processandoSolicitacaoExame, setProcessandoSolicitacaoExame] = useState(false)
  const [processandoExames, setProcessandoExames] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [mouseX, setMouseX] = useState(0)
  const [mouseY, setMouseY] = useState(0)

  const fetchSolicitacaoExame = useCallback(async () => {
    if (solicitacao) {
      setSolicitacaoExame(solicitacao)
      return
    }
    const result = await solicitacaoExameService.listarSolicitacaoSimplificadaAsync(idSolicitacaoExame, setProcessandoSolicitacaoExame)
    setSolicitacaoExame(result)
  }, [idSolicitacaoExame, solicitacao])

  useEffect(() => {
    fetchSolicitacaoExame()
  }, [fetchSolicitacaoExame])

  const fetchExames = useCallback(async () => {
    if (solicitacao?.exSols) {
      setExamesSolicitados(solicitacao.exSols)
      return
    }
    const result = await solicitacaoExameService.listarExamesDeSolicitacaoAsync(idSolicitacaoExame, setProcessandoExames)
    setExamesSolicitados(result)
  }, [idSolicitacaoExame, solicitacao])

  useEffect(() => {
    if (!omitirExamesSolicitados) fetchExames()
  }, [omitirExamesSolicitados, fetchExames])

  // eslint-disable-next-line
  const handleClickExameSolicitado = (id, novaAba) => {
    if (novaAba) {
      window.open(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${id}`)
    }
  }

  const handleClickSolicitacaoExame = (idSolicitacao, novaAba) => {
    dispatch(setIdSolicitacaoExame(idSolicitacao))
    if (novaAba) {
      window.open(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${idSolicitacao}`, '_blank', 'noreferrer')
    } else {
      router.history.push(`/solicitacaoexame/fichasolicitacaoexame/detalhar/${idSolicitacao}`)
    }
  }

  const handleContextMenu = (event) => {
    event.preventDefault()
    setAnchorEl(event.currentTarget)
    setMouseX(event.clientX)
    setMouseY(event.clientY)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickNovaAba = () => {
    handleClickSolicitacaoExame(idSolicitacaoExame, true)
    handleClose()
  }

  const handleClickNewAba = () => {
    handleClickExameSolicitado(idSolicitacaoExame, true)
    handleClose()
  }

  return (
    <Card className={classes.root}>
      {processandoSolicitacaoExame || !solicitacaoExame ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          {/* ÁREA SUPERIOR INTERATIVA: Toda essa região é um botão gigante intuitivo */}
          <div
            className={classes.clickableArea}
            onClick={() => handleClickSolicitacaoExame(idSolicitacaoExame)}
            onContextMenu={handleContextMenu}
          >
            <CardHeader
              style={{ padding: '24px 24px 16px 24px' }}
              avatar={
                <ObjetoAvatar tipo="CASO" />
              }
              title={
                <Typography className={classes.headerTitle}>Solicitação de Exame</Typography>
              }
              action={
                <div style={{ display: 'flex', alignItems: 'center', paddingRight: '8px', marginTop: '4px' }}>
                  <ChevronRightIcon className={classes.chevronIcon} />
                </div>
              }
            />
            
            <Divider style={{ margin: '0 24px 20px 24px' }} />

            {/* Grid Unificado de Cápsulas de Informação (Estilo Caso Premium) */}
            <Grid container spacing={2} className={classes.metaGrid}>
              {/* 1. Autoridade Solicitante */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <PersonIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Autoridade Solicitante</Typography>
                    <Tooltip title={solicitacaoExame?.autReq?.nome?.toUpperCase() === 'OUTRO' ? solicitacaoExame?.autoridadeRequisitanteInput?.toUpperCase() : solicitacaoExame.autReq?.nome?.toUpperCase() || ''} arrow>
                      <Typography className={classes.metaValue}>
                        {solicitacaoExame?.autReq?.nome?.toUpperCase() === 'OUTRO' ? solicitacaoExame?.autoridadeRequisitanteInput?.toUpperCase() : solicitacaoExame.autReq?.nome?.toUpperCase()}
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              </Grid>

              {/* 2. Setor Solicitante */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <BusinessIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Setor Solicitante</Typography>
                    <Tooltip title={solicitacaoExame.setReq ? solicitacaoExame.setReq?.nome?.toUpperCase() : 'NÃO INFORMADO'} arrow>
                      <Typography className={classes.metaValue}>
                        {solicitacaoExame.setReq ? solicitacaoExame.setReq?.nome?.toUpperCase() : 'NÃO INFORMADO'}
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              </Grid>

              {/* 3. Destino do Exame */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <LocationOnIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Destino do Exame</Typography>
                    <Tooltip title={`${solicitacaoExame.setDest?.nome?.toUpperCase()} / ${solicitacaoExame.setDest?.divisao?.sigla?.toUpperCase()}`} arrow>
                      <Typography className={classes.metaValue}>
                        {`${solicitacaoExame.setDest?.nome?.toUpperCase()} / ${solicitacaoExame.setDest?.divisao?.sigla?.toUpperCase()}`}
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              </Grid>

              {/* 4. Data da Solicitação */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <CalendarTodayIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Data da Solicitação</Typography>
                    <Typography className={classes.metaValue}>
                      {moment(solicitacaoExame.data).format('DD/MM/YYYY HH:mm')}
                    </Typography>
                  </div>
                </div>
              </Grid>

              {/* 5. Documento da Solicitação */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <DescriptionIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Documento da Solicitação</Typography>
                    <Tooltip title={`${solicitacaoExame.tipoDocumento?.toUpperCase() || 'NÃO INFORMADO'}${solicitacaoExame.numeroDocumento ? ` ${solicitacaoExame.numeroDocumento}` : ''}`} arrow>
                      <Typography className={classes.metaValue}>
                        {solicitacaoExame.tipoDocumento?.toUpperCase() || 'NÃO INFORMADO'}
                        {solicitacaoExame.numeroDocumento ? ` ${solicitacaoExame.numeroDocumento}` : ''}
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              </Grid>

              {/* 6. Tipo de Procedimento */}
              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.metaItem}>
                  <GavelIcon className={classes.metaIcon} />
                  <div className={classes.metaTextContainer}>
                    <Typography className={classes.metaLabel}>Tipo de Procedimento</Typography>
                    <Tooltip title={`${solicitacaoExame.tipoProc?.nome?.toUpperCase() || 'NÃO INFORMADO'}${solicitacaoExame.numeroProcedimento ? ` ${solicitacaoExame.numeroProcedimento}` : ''}`} arrow>
                      <Typography className={classes.metaValue}>
                        {solicitacaoExame.tipoProc?.nome?.toUpperCase() || 'NÃO INFORMADO'}
                        {solicitacaoExame.numeroProcedimento ? ` ${solicitacaoExame.numeroProcedimento}` : ''}
                      </Typography>
                    </Tooltip>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>

          {/* Menu de Contexto (Botão Direito) */}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            anchorReference="anchorPosition"
            anchorPosition={{ top: mouseY, left: mouseX }}
          >
            <MenuItem onClick={handleClickNovaAba}>Abrir em nova aba</MenuItem>
          </Menu>

          {/* ÁREA INFERIOR INDEPENDENTE: Exames Solicitados */}
          {!omitirExamesSolicitados && (
            <div className={classes.contentArea}>
              {processandoExames && !examesSolicitados ? (
                <div className={classes.carregando}>
                  <CircularProgress disableShrink />
                </div>
              ) : (
                <>
                  <Typography className={classes.sectionTitle}>
                    Exames Solicitados
                  </Typography>
                  
                  <Grid container spacing={2} alignItems="stretch">
                    {examesSolicitados &&
                      examesSolicitados.map((exameSolicitado) => (
                        <Grid key={exameSolicitado.id} item xs={12} sm={6} md={4} style={{ display: 'flex' }}>
                          <div style={{ width: '100%' }}>
                            <CardExameSolicitado 
                              exameSolicitado={exameSolicitado} 
                              handleClick={handleClickExameSolicitado} 
                              aninhado={true}
                            />
                          </div>
                        </Grid>
                      ))}
                  </Grid>
                </>
              )}
            </div>
          )}
        </div>
      )}
    </Card>
  )
}
